<div class="content">

  <div class="page-title">
    <h1>Job Reports</h1>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.companyId" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.locationId" [companyId]="filter.companyId" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Engineer</label>
            <app-technician-picker [technicianId]="filter.technicianId" [_placeholder]="'All'" (onTechnicianSet)="onTechnicanChange($event)"></app-technician-picker>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <label>Job Number</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.job_Num" />
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
        </div>
      </div>

    </form>
  </div>

  <app-loading-icon *ngIf="loading"></app-loading-icon>

  <div class="buffer-bottom" style=" display: flex; align-content: center; justify-content: center;">

    <div>
      <i aria-hidden="true" class="fa fa-file-pdf-o passed" placement="right"> Passed Report</i>
      <i aria-hidden="true" class="fa fa-file-pdf-o failed" placement="right"> Failed Report</i>
      <i aria-hidden="true" class="fa fa-file-pdf-o missing" placement="right"> Missing Report</i>
    </div>
  </div>

  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                 [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">

    <ngx-datatable-column name="Download">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a *ngIf="row.hasPassed" href="javascript:void(0)" class="fa fa-file-pdf-o passed" aria-hidden="true" placement="right" ngbTooltip="PASSED REPORT" (click)="downloadReport(row.id,row.job_No,0)"></a>
        <a *ngIf="row.hasFailed" href="javascript:void(0)" class="fa fa-file-pdf-o failed" aria-hidden="true" placement="right" ngbTooltip="FAILED REPORT" (click)="downloadReport(row.id,row.job_No,1)"></a>
        <a *ngIf="row.hasMissing" href="javascript:void(0)" class="fa fa-file-pdf-o missing" aria-hidden="true" placement="right" ngbTooltip="NOT PRESENTED REPORT" (click)="downloadReport(row.id,row.job_No,2)"></a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Company" prop="company_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Job Number" prop="job_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Contract" prop="contract_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Engineer" prop="engineer_Name_Formatted">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column name="Week Commencing" prop="week_Commencing">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.week_Commencing != null">{{ value | date: 'dd/MM/yyyy' }}</div>
        <div *ngIf="row.week_Commencing == null">N/A</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Completed Date" prop="completed_Date">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.completed_Date != null">{{ value | date: 'dd/MM/yyyy' }}</div>
        <div *ngIf="row.completed_Date == null">N/A</div>
      </ng-template>
    </ngx-datatable-column>



  </ngx-datatable>
</div>
